export default {"src":"/_next/static/media/zil.6e88e3c9.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};